import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useSaleSoDetailModel } from "./saleSoDetailModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, cm } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { addDesc, editDesc, lookDesc } = useSaleSoDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: Locale["Sales Qty"],//"销售数量",
            value: typeDesc[mode].numAll.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Sales Amount"],//"销售金额",
            value: typeDesc[mode].saleAll.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Discount Amount"],//"优惠金额",
            value: Math.abs(typeDesc[mode].discountAll).toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: Locale["taxation"],// "税费",
        //     value: typeDesc[mode].taxationAll.toFixed(2),
        //     color: DescriptionColorEnum.red,
        //     status: true
        // },
        {
            label: Locale["Receivable Amount"],//"应收金额",
            value: typeDesc[mode].receivableAll.toFixed(2),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}